<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.25 1.5H9.75V5.25H15.75V7.5H9.75V10.5H13.5V12.75H9.75V16.5H8.25V12.75H4.5V10.5H8.25V7.5H2.25V5.25H8.25V1.5Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
  const props = defineProps({
    color: {
      type: String,
      default: '#0000FF',
    },
    size: {
      type: Number,
      default: 18,
    },
  })
</script>
